import { AxiosInstance } from 'axios'

export interface PremiseLevelPricingData {
  sprn: number;
  offer: string;
  startdate: string;
  enddate: string;
}

export default function PremiseLevelPricing(client: AxiosInstance) {
  async function get(sprn: number) {
    try {
      // Make the API call using the authenticated client
      const response = await client.get<any>(`premise-level-pricing?sprn=${sprn}`)
      
      // Ensure we return an array
      const data = response?.data?.data
      if (data && Array.isArray(data)) {
        return data
      } else if (data) {
        // If data exists but is not an array, wrap it in an array
        return [data]
      } else {
        // Return empty array if no data
        return []
      }
    } catch (err) {
      console.error('Error fetching premise level pricing:', err)
      return []
    }
  }

  return {
    get,
  }
}
